module.exports = __webpack_public_path__ + "media/images/demo_tests/shapeshift-cfb5f6a563f8e753f96cb9742c0405e8.gif";